<template>
  <section-page full-height>
    <div class="upgrade_message">
      <p class="upgrade_message--heading">Upgrade Required</p>
      <p class="upgrade_message--content">Upgrade your account today and gain access to advanced Key Performance Indicator (KPI) and Reporting.</p>
      <p class="upgrade_message--content">Knowing the numbers that drive our businesses is crucial to building predictability.  A business owner must have up-to-date data and information when making decisions and deciding where to spend their marketing dollars.</p>
      <p class="upgrade_message--content">ForeFront makes it easy to gather and review the key numbers we need to manage to do more deals and generate consistent review.</p>
      <p class="upgrade_message--content"><a @click="openBillingPortal">Upgrade your account today</a> and unlock Advanced KPI & Reporting for your business</p>

      <div class="flex flex-centered">
        <button-outlined
          class="upgrade_message--button"
          @click="openBillingPortal"
          size="">Upgrade Your Account Now
        </button-outlined>
      </div>
    </div>
  </section-page>
</template>

<script>
export default {
  name: "StatsUpgradeTab",
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.upgrade_message {
  max-width: 700px;
  margin: 0 auto;
  padding: 4rem 0 2rem;

  &--heading {
    margin-bottom: 1.3rem;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
  }

  &--content {
    margin-bottom: 10px;
    font-size: 1.125rem;
    line-height: 1.4;

    a {
      font-weight: bold;
    }
  }

  &--button {
    margin-top: 1.5rem;
  }
}
</style>
